import { render, staticRenderFns } from "./SpotMetricsPanelControlTable.vue?vue&type=template&id=3ef642ec&scoped=true&lang=pug&"
import script from "./SpotMetricsPanelControlTable.vue?vue&type=script&lang=ts&"
export * from "./SpotMetricsPanelControlTable.vue?vue&type=script&lang=ts&"
import style0 from "./SpotMetricsPanelControlTable.vue?vue&type=style&index=0&id=3ef642ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef642ec",
  null
  
)

export default component.exports